import clsx from "clsx";
import { ReactNode } from "react";

/** House button styles for form footers. */
export const primaryButtonClass =
  "h-11 px-6 rounded-full flex items-center justify-center gap-2 text-[14px] font-semibold text-white bg-gradient-to-r from-accent to-accent-bright shadow-lg shadow-indigo-500/20 hover:shadow-glow-sm hover:-translate-y-0.5 transition-all duration-300 disabled:opacity-60 disabled:hover:translate-y-0 disabled:cursor-wait";

export const secondaryButtonClass =
  "h-11 px-5 rounded-full flex items-center justify-center gap-2 text-[13px] font-semibold text-light-gray border border-edge hover:text-text-primary hover:border-indigo-400/40 transition-all duration-200 disabled:opacity-50";

export const dashedButtonClass =
  "w-full h-11 rounded-full flex items-center justify-center gap-2 text-[13px] font-semibold text-light-gray border border-dashed border-edge-strong hover:text-text-primary hover:border-indigo-400/40 hover:bg-overlay-hover transition-all duration-200 disabled:opacity-50";

/** Label for controls that render their own field group (radios, chip lists). */
export const FieldLabel = ({ children }: { children: ReactNode }) => (
  <label className="block text-[13px] font-medium text-light-gray">
    {children}
  </label>
);

interface FormSectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  /** Extra classes for the field grid. */
  className?: string;
}

/**
 * A titled group of fields inside a form card — hairline separated rather than
 * nested in its own card, so long forms stay flat and scannable.
 */
const FormSection = ({
  title,
  description,
  children,
  className,
}: FormSectionProps) => (
  <section className="px-6 sm:px-8 py-6 smallTablet:px-4 smallTablet:py-5 border-t border-edge-faint first:border-t-0">
    <p className="flex items-center gap-2 text-[11px] font-semibold text-light-gray uppercase tracking-[0.14em]">
      <span className="w-1.5 h-1.5 rounded-full bg-accent shrink-0" />
      {title}
    </p>
    {description ? (
      <p className="mt-1.5 text-[13px] font-medium text-light-gray">
        {description}
      </p>
    ) : null}

    <div
      className={clsx(
        "mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5 smallTablet:gap-y-4",
        className
      )}
    >
      {children}
    </div>
  </section>
);

export default FormSection;
